import React, { createContext, useState, useEffect } from 'react';
import { getTheme } from '../config/themeConfig';

// Create the context
export const ThemeContext = createContext();

// Create the provider component
export const ThemeProvider = ({ children }) => {
  const [theme, setTheme] = useState('light'); // Default theme
  const [themeData, setThemeData] = useState(getTheme('light'));

  // Load theme from localStorage on component mount
  useEffect(() => {
    const savedTheme = localStorage.getItem('theme') || 'light';
    setTheme(savedTheme);
    setThemeData(getTheme(savedTheme));
    
    // Apply theme class to app container
    document.querySelector('.app')?.classList.remove('dark', 'light', 'hclBlue', 'unica', 'maxAI', 'chakra');
    document.querySelector('.app')?.classList.add(savedTheme);
  }, []);

  // Function to change theme
  const changeTheme = (newTheme) => {
    setTheme(newTheme);
    setThemeData(getTheme(newTheme));
    localStorage.setItem('theme', newTheme);
    
    // Update app class for CSS variables
    document.querySelector('.app')?.classList.remove('dark', 'light', 'hclBlue', 'unica', 'maxAI', 'chakra');
    document.querySelector('.app')?.classList.add(newTheme);
  };

  return (
    <ThemeContext.Provider value={{ theme, themeData, changeTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};
